import { Bridge } from '@mc/mc-jsbridge'

export const getAppInfo = () => {
  if (Bridge.prepared) {
    const { ret, data } = Bridge.getAppInfo()
    if (ret && data) {
      return data
    } else {
      return {}
    }
  } else {
    return {}
  }
}

export const isMeicaiHarmony = () => {
  return !!window.matrix.isMallHarmonyApp
}
